import React from 'react';

import { OperatingLeaseFinancialDetails } from 'cpes-common';
import { ValueOrDefaultError } from 'components/value-or-default-error';
import { TranslationFormat, useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import { DataOverview, DefinitionListHorizontal, DefinitionListItem } from '@cp-shared-19/frontend-ui';

export const BaseSection: React.FC<{ details: OperatingLeaseFinancialDetails }> = ({ details }) => {
    const { startDate, endDate, mileageLastRecalculation, downPayment, bailAmount } = details;
    const { t, f } = useTranslationWithFormatting('financial-details');

    const baseSectionFields: DefinitionListItem[] = [
        {
            label: t('baseSection.startDate'),
            value: <ValueOrDefaultError value={f(startDate, TranslationFormat.DATE)} />,
        },
        {
            label: t('baseSection.endDate'),
            value: <ValueOrDefaultError value={f(endDate, TranslationFormat.DATE)} />,
        },
        {
            label: t('baseSection.mileageLastRecalculation.label'),
            value: f(mileageLastRecalculation, TranslationFormat.DISTANCE),
            tooltip: t('baseSection.mileageLastRecalculation.tooltip'),
        },
        {
            label: t('baseSection.downPayment'),
            value: f(downPayment, TranslationFormat.CURRENCY),
        },
        {
            label: t('baseSection.bailAmount.label'),
            value: f(bailAmount, TranslationFormat.CURRENCY),
            tooltip: t('baseSection.bailAmount.tooltip'),
            labelId: t('baseSection.bailAmount.label'),
        },
    ].filter(item => !!item.value);

    return (
        <DataOverview titleLevel={5} title={t('baseSection.title')}>
            <DefinitionListHorizontal list={baseSectionFields} />
        </DataOverview>
    );
};
